<template>
  <div class="OrderDocuments">
    <app-files-block
      :files="documents"
      title="Документы к заказу"
      tooltip="Документы к этому заказу"
      titleEmpty="Нет документов"
      class="OrderDocuments__files-block"
      height="300px"
    >
      <template #item>
        <app-files-block-item
          v-for="item in documents"
          :key="item.link"
          class="app-files-block__content-item"
          :file="item"
          :url="item.link"
          :contentType="item.mime"
          :isGetFile="item.isGetFile"
        >
          <template #content="{ file }">
            <span class="app-files-block-item__title">{{ file.name }}</span>
            <ul class="OrderDocuments__document-list">
              <li class="OrderDocuments__document-list-item" v-if="file.type">
                Тип: {{ file.type }}
              </li>
              <li class="OrderDocuments__document-list-item" v-if="file.state">
                Статус: {{ file.state }}
              </li>
              <li class="OrderDocuments__document-list-item" v-if="false">
                Описание: {{ file.description }}
              </li>
            </ul>
          </template>
        </app-files-block-item>
      </template>
    </app-files-block>
  </div>
</template>

<script>
export default {
  name: 'OrderDocuments',
  components: {
    AppFilesBlock: () =>
      import('@/components/common/AppFilesBlock/AppFilesBlock'),
    AppFilesBlockItem: () =>
      import('@/components/common/AppFilesBlock/AppFilesBlockItem'),
  },
  props: {
    documents: {
      type: Array,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.OrderDocuments {
  height: 100%;
  background: #fff;
  box-shadow: $box-shadow-card-1;

  @include media-xs() {
    min-height: auto;
  }

  &__files-block {
    height: 100%;

    @include media-xs() {
      padding-top: 0 !important;

      &::before {
        display: none;
      }
    }
  }

  &__document-list {
    @include list-reset;

    margin-top: 5px;
  }

  &__document-list-item {
    padding: 5px 0;
    font-weight: 300;
    line-height: 17px;
    color: rgba(33, 33, 33, 0.5);
  }
}
</style>
